import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { isNullOrUndefined, ToastService } from '../core';
import { Activity, AmmendImmActivityFilter, ConfigurationApi, ImmigrationActivity, LookupApi, CandidateApi, FilterParams, AdditionalInfo } from '../core/api.gen';
import { CommonService } from '../core/common.service';
import { CSVReportService } from '../core/csvreport.service';
import { DialogService } from '../core/dialog.service';
import { LoaderService } from '../core/loader.service';
import { LookupTypeKeys } from '../shared/lookup-type-keys';
import { nullSafe } from '../utils';


@Component({
  selector: 'eos-imm-task-amendment',
  templateUrl: './imm-task-amendment.component.html',
  styleUrls: ['./imm-task-amendment.component.scss']
})
export class ImmTaskAmendmentComponent implements OnInit {
  activities: ImmigrationActivity[] = [];
  activity:any;
  filterparams:any;
  isAscendic:boolean=false;

  activityFilter = new UntypedFormGroup({
    visaType: new UntypedFormControl(null, [Validators.required]),
    country: new UntypedFormControl(null, [Validators.required]),
    officeLE: new UntypedFormControl(),
    officeToBeVisited: new UntypedFormControl(),
    isActive:new UntypedFormControl(true)
  });
  visaTypes = [];
  countries = [];
  officeLE = [];
  officeToBeVisited = [];
  visas = [];
  activityTypes = [
    {
      id: 100,
      displayText: 'Email',
      disabled: true
    },
    {
      id: 101,
      displayText: 'Profile update',
    },
    {
      id: 102,
      displayText: 'External',
      disabled: true
    },
    {
      id: 104,
      displayText: 'Document upload',
      disabled: true
    }
  ];
  selectedCountry:any;

  constructor(
    private configurationService: ConfigurationApi,
    private common: CommonService,
    private toast:ToastService,
    private lookupApi: LookupApi,
    private loader: LoaderService,
    private dialogService: DialogService,
    private router: Router,
    private candidateService:CandidateApi,
    private csvreportService: CSVReportService
  ) { }

  ngOnInit() {
    this.loadFilterData();
    this.activityFilter.controls['country'].valueChanges.subscribe(val => {
      if (val) {
        this.visaTypes = this.visas.filter(x => x.parentFieldId === val.id);
      }
    });
    this.valuechangeSubscription();
  }
  loadFilterData() {

    this.lookupApi.getLookupFieldsByTypes([LookupTypeKeys.VISA_TYPE])
      .subscribe(resp => {
        this.visas = resp;
      });

    this.lookupApi.getLookupFieldsByType(LookupTypeKeys.OFFICE_LOCATION_COUNTRY, 0, 0)
      .subscribe(resp => {
        this.countries = resp.filter(i => [1048, 1047, 1052, 1049, 1050, 1051, 1055, 1053, 13410].includes(i.id))
        this.getActivities();
      }
      );  
  }
  clearFilter(){
    this.filterparams=new FilterParams();
    this.candidateService.saveFilterParams('IMMACTIVITY',this.filterparams).subscribe();
  }
  saveFilter(){
    const filterparam=new FilterParams()
    const form = this.activityFilter.getRawValue();   
    filterparam.visaCountry=form.country!=null?form.country.displayText:null;
    filterparam.visaTypeId=form.visaType!=null?[form.visaType.id]:[];
    filterparam.officeToBeVisitedId=form.officeToBeVisited!=null?[form.officeToBeVisited]:[];
    filterparam.legalEntityId=form.officeLE!=null?[form.officeLE]:[]
    this.candidateService.saveFilterParams('IMMACTIVITY',filterparam).subscribe(
    resp=>{
      this.getActivities()
    });
  }
  createActivity() {
    const form = this.activityFilter.getRawValue();
    let redirectUrl = 'configure-immactivities/create'
    redirectUrl = form.country != null ? redirectUrl + '/' + form.country.value : redirectUrl;
    redirectUrl = form.visaType != null ? redirectUrl + '/' + form.visaType.value : redirectUrl;
    this.router.navigateByUrl(redirectUrl);

  }
  onSubmit() {
    this.saveFilter();
  }
  getActivities() {
      this.loader.show();
      const filter = this.getFormData();
      this.configurationService.getImmActivities(filter)
        .pipe(
          finalize(() => this.loader.clear()))
        .subscribe(resp => {
          resp.immigrationActivities.map(act => {
            act['activityTypeString'] = this.activityTypes.find(a => a.id === act.activityType);
            return act;
          });
          this.activities = resp.immigrationActivities.filter(act => act.order !== 0).sort((a, b) => a.order < b.order ? -1 : 1).concat(resp.immigrationActivities.filter(act => act.order === 0));
          this.isAscendic = true;
          this.activity=resp.immigrationActivities.filter(act => act.order !== 0).sort((a, b) => a.order < b.order ? -1 : 1).concat(resp.immigrationActivities.filter(act => act.order === 0));
          this.onChange(this.activityFilter.controls['isActive'].value);
          this.filterparams=resp.filter;
          if(resp.filter){
            this.selectedCountry=this.countries.find(x=>x.displayText==this.filterparams.visaCountry);
            this.activityFilter.controls['country'].setValue(this.selectedCountry);
            if(this.filterparams && this.filterparams.visaTypeId && this.filterparams.visaTypeId.length>0){
              this.activityFilter.controls['visaType'].setValue(this.visaTypes.find(x=>x.id==this.filterparams.visaTypeId[0]));
              this.loadData(this.visaTypes.find(x=>x.id==this.filterparams.visaTypeId[0]));
            }
           }        
        });
  }
  editActivity(activity: ImmigrationActivity) {
    // this.dialogService.showActivityAmendEdit(activity, this.countries)
    //   .result.then(resp => {
    //     this.getActivities();
    //   }, dismiss => {
    //     this.getActivities();
    //   });
    this.configurationService.getImmActivitiesById(activity.id).subscribe(
      res => {
        if (res) {
          this.router.navigateByUrl(`configure-immactivities/edit/${res.id}`);
        }
      }
    );
  }
  clearForm() {
    this.activityFilter.reset();
    this.activityFilter.patchValue({ isCandidate: true });
    this.activities = [];
    this.activity=[];
    this.clearFilter();
  }
  cloneActivity(activity: Activity) {
    // this.dialogService.showActivityAmendCreate(
    //   this.employeeCategories, 
    //   this.countries, this.pbTypes, 
    //   this.activityTypes,
    //    activity,
    //     this.activityFilter.value.isWSO)
    //   .result.then(resp => {
    //     this.getActivities();
    //   }, dismiss => {
    //     this.getActivities();
    //   });
  }
  loadData($event) {
    const country = this.activityFilter.get('country').value;

    if (country) {
      this.restControls();
      const countryCode = country.value
      this.lookupApi.getOfficeLEByCountryCode(countryCode)
        .subscribe(resp => {
          this.officeLE = resp;
        });
      this.lookupApi.getOfficeLocations(countryCode)
        .subscribe(resp => {
          this.officeToBeVisited = resp;
          
          if(this.filterparams && this.filterparams.officeToBeVisitedId && this.filterparams.officeToBeVisitedId.length>0){
            let officeToBeVisited=this.officeToBeVisited.find(x=>x.id==this.filterparams.officeToBeVisitedId[0]);
            if(officeToBeVisited )
            this.activityFilter.controls['officeToBeVisited'].setValue(officeToBeVisited.id);
          }
          if(this.filterparams && this.filterparams.legalEntityId && this.filterparams.legalEntityId.length>0){
            this.activityFilter.controls['officeLE'].setValue(this.filterparams.legalEntityId[0]);
          }
          
         
        });
    }   
  }

  valuechangeSubscription() {
    this.activityFilter.get('country')
      .valueChanges
      .subscribe(x => {
        this.activityFilter.get('visaType').reset();
        this.restControls();
      })
  }

  restControls() {
    this.activityFilter.get('officeLE').reset();
    this.activityFilter.get('officeToBeVisited').reset();
  }

  getFormData() {
    const form = this.activityFilter.getRawValue();
    const filter = new AmmendImmActivityFilter({
      country: form.country,
      visaType: form.visaType,
      officeToBeVisited: form.officeToBeVisited,
      officeLE: form.officeLE
    });
    return filter;
  }

  onChange($event){
    if($event){
      this.activities=this.activity.filter(x=>x.isActive==true);
    }
    else{
      this.activities=this.activity.filter(x=>x.isActive==true || x.isActive==false)
    }
  }


sort() {
    if (!this.isAscendic) {
      this.activities = this.activities.filter(act => act.order !== 0).sort((a, b) => a.order < b.order ? -1 : 1).concat(this.activities.filter(act => act.order === 0));
      this.isAscendic = true;
    }
    else {
      this.activities = this.activities.filter(act => act.order !== 0).sort((a, b) => a.order > b.order ? -1 : 1).concat(this.activities.filter(act => act.order === 0));
      this.isAscendic = false;
    }
  }

  exportImmigrationActivity() {   
    const filter = this.getFormData();     
    const country = this.activityFilter.get('country').value.displayText;
    const visa = this.activityFilter.get('visaType').value.displayText;       
    this.csvreportService.downloadimmigrationActivityConfigReport(filter,null,nullSafe(() =>this.activityFilter.controls['isActive'].value,false))
      .pipe(finalize(() => {        
      })).subscribe(resp => {
         let fileName = `Immigration Activities_${country}_${visa}.xlsx`;        
        
        if ((window.navigator as any).msSaveOrOpenBlob) {
          (window.navigator as any).msSaveBlob(resp, fileName);
        } else {
          const url = window.URL.createObjectURL(resp);
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.setAttribute("style", "display: none");
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        }
      });
  }

  updateOrder(act){
    const immActivity = this.getImmActivity(act);
    if (immActivity.isActive && immActivity.order <= 0) {
      this.toast.warning("Order should be greater than zero for an active activity")
    }
    else {    
    this.configurationService.amendImmigrationActivity(immActivity)
      .pipe(finalize(() => {
        this.loader.clear();
      }))
      .subscribe(resp => {
        if (resp) {
          if(resp.statusCode==400){
            this.toast.warning(resp.data)
          }
          else{
            this.toast.success('Order successfully updated');
          }        
        }
      }, err => {
        this.toast.error('An error occurred. Please try again.');
      }
      );
  }
  }
  getImmActivity(rawValues) {
    const internalAct = new ImmigrationActivity(
      {
        activityType: rawValues.activityType,
        order: rawValues.order,
        id:rawValues.id,
        header: rawValues.header,
        description: rawValues.description,
        visaTypeId: rawValues.visaTypeId,
        additionalInfoObject:   !isNullOrUndefined(rawValues.additionalInfo)? this.checkIfAdditionalInfoNull(JSON.parse(rawValues.additionalInfo)):null,
        isActive:rawValues.isActive
      });
    return internalAct;
  }
  checkIfAdditionalInfoNull(rawValues) {
    const obj = new AdditionalInfo({
      immigrationCaseTypeId: rawValues.immigrationCaseTypeId,
      preboardingTypeId: rawValues.preboardingTypeId,
      officeToBeVisited: rawValues.officeToBeVisited,
      currentVisaStatusId: rawValues.currentVisaStatusId,
      nationality: rawValues.nationality,
      typeOfSupport: rawValues.typeOfSupport,
      officeLE: rawValues.officeLE,
      excludedNationality: rawValues.excludedNationality,
      employeeCurrentLocation: rawValues.employeeCurrentLocation,
      gender: rawValues.gender,
      shortTermVisa: rawValues.shortTermVisa,
      specialExpat: rawValues.specialExpat,
      ranks : rawValues.ranks,
      nationalityType: rawValues.nationalityType
    })
    Object.keys(obj).forEach(key => {
      if (obj[key] === null || obj[key] === undefined || nullSafe(() => obj[key].length === 0)) {
        delete obj[key];
      }
    });
    return !this.removeEmpty(obj) ? obj : null;
  }

  removeEmpty(additionalInfo) {
    return Object.values(additionalInfo).every(x => (x === null));
  }
}
